// eslint-disable-next-line import/prefer-default-export
export enum GTMEvents {
  STEP_ONE_VIEW = 'eventStep1',
  STEP_TWO_VIEW = 'eventStep2',
  STEP_THREE_VIEW = 'eventStep3',
  STEP_FOUR_VIEW = 'eventStep4',
  STEP_SOUSCRIPTION_VIEW = 'eventStep5',
  SUBMIT_SOUSCRIPTION_CALL = 'eventStep6',

  SUBMIT_SOUSCRIPTION_VALIDATED = 'eventStep7',

  CALL_ME_STEP_ONE = 'eventCallStep1',
  CALL_ME_STEP_TWO = 'eventCallStep2',
  CALL_ME_STEP_THREE = 'eventCallStep3',
  CALL_ME_STEP_FOUR = 'eventCallStep4',
  CALL_ME_SOUSCRIPTION = 'eventCallStep5',
  CALL_ME_SOUSCRIPTION_SUCCESS = 'eventCallStep6',

  FAQ_VIEW = 'eventPagesFAQ',
  BLOG_VIEW = 'eventPagesBlog',
  CTA_BLOG_VIEW = 'eventCtaPrimaryBlog',

  FUNNEL_STEP = 'funnel_step',
  LEAD_CONFIRMED = 'lead_confirmed',
  RDV_CONFIRMED = 'rdv_confirmed',
}
